import React from 'react'

import {createMarkup} from './util'


const Text = (props) => {
  const childBits = props.children.split('\n')

  if (childBits.length === 1) {
    return (
      <p className={props.className} dangerouslySetInnerHTML={createMarkup(childBits[0])} />
    )
  }

  const children = childBits
    .filter(x => x.trim() !== '')
    .map((x, i) => <p key={i} dangerouslySetInnerHTML={createMarkup(x)} />)

  return (
    <div className={props.className}>{children}</div>
  )
}

export default Text



// WEBPACK FOOTER //
// ./src/Text.js